<template>
  <div>
    <v-toolbar color="primary" dark>
      <v-toolbar-title>{{ $t('titles.users.bulkCreate') }}</v-toolbar-title>

      <v-spacer />

      <v-btn dark icon @click="cancel">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container fluid>
      <BulkCreateInputs
        :role-id.sync="roleId"
        :object-id.sync="objectId"
        :send-invitation.sync="sendInvitation"
        :type-role="typeRole"
        :readonly="readonly"
        :entity-id="entityId"
        :team-id="teamId"
      />
      <template v-if="roleId && objectId">
        <BulkCreateList
          :title="role.text"
          :items="items"
          @form="openForm"
          @delete="deleteItem"
        />
        <BulkCreateList
          v-if="role.type === 'player'"
          :title="$t('titles.global.familiar')"
          :items="items"
          :is-familiar="true"
          @form="openForm($event, true)"
          @delete="deleteItem($event, true)"
        />
        <BulkCreateForm
          v-if="dialog"
          :item.sync="item"
          :is-player="role.type === 'player'"
          @submit="saveUser"
          @close="close"
        />
      </template>
    </v-container>
    <v-card-text />
    <v-divider />

    <v-card-actions>
      <v-spacer />
      <meta-button type="cancel" @click="cancel" />
      <meta-button
        type="save"
        :disabled="!items.length"
        :loading="loading"
        @click="submit"
      />
    </v-card-actions>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import BulkCreateForm from './BulkCreateForm.vue'
import BulkCreateInputs from './BulkCreateInputs.vue'
import BulkCreateList from './BulkCreateList.vue'
export default {
  name: 'UsersBulkCreate',
  components: { BulkCreateInputs, BulkCreateList, BulkCreateForm },
  props: {
    entityId: { type: String },
    teamId: { type: String },
    typeRole: { type: String },
  },
  data() {
    return {
      roleId: '',
      objectId: '',
      sendInvitation: true,
      items: [],
      item: {},
      editedIndex: -1,
      readonly: false,
      dialog: false,
    }
  },
  computed: {
    ...mapState({ loading: (state) => state.users.loading }),
    ...mapGetters({
      roleSelectList: 'roles/selectListFiltered',
    }),
    role() {
      return (
        this.roleSelectList.find((item) => item.value === this.roleId) || {}
      )
    },
  },
  methods: {
    ...mapActions({
      bulkCreate: 'users/bulkCreate',
    }),
    openForm(item) {
      this.dialog = true
      this.editedIndex = this.items.indexOf(item)
      this.item = item ? Object.assign({}, item) : {}
    },
    deleteItem(item) {
      let index = this.items.indexOf(item)
      confirm(this.$t('titles.global.confirmDelete')) &&
        this.items.splice(index, 1)
    },
    saveUser() {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.item)
      } else {
        this.items.push(this.item)
      }
      this.close()
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.item = {}
        this.editedIndex = -1
      }, 300)
    },
    submit() {
      const payload = {
        items: this.items,
        typeRole: this.role.type,
        roleId: this.roleId,
        objectId: this.objectId,
        sendInvitation: this.sendInvitation,
      }
      this.bulkCreate(payload).then(() => this.cancel())
    },
    cancel() {
      this.$emit('close')
      if (this.$route.name === 'bulk-create-users') this.$router.back()
    },
  },
  async mounted() {
    if (this.entityId && this.typeRole === 'coordinator') {
      this.objectId = this.entityId
      this.readonly = true
    } else if (this.teamId && ['trainer', 'player'].includes(this.typeRole)) {
      this.objectId = this.teamId
      this.readonly = true
    }
  },
}
</script>
